import Axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Table, Button, message } from 'antd';
// テーブル強化 PJ Ph.3 拡大: 列リサイズ + ソート + 省略
import {
  PageContainer,
  useResizableColumns,
  ellipsisColumn,
  textSorter,
  StatusBadge,
} from '../../common';

const GroupListPage = (props) => {
  // console.log({ props });
  const { user } = props;
  const [groupInfo, setGroupInfo] = useState([]);

  const readDB = async () => {
    try {
      if (!user.userData) return null;
      // console.log(user.userData.isAuth);
      if (user.userData.isAuth) {
        const res = await Axios.get('/api/group/');
        // console.log(res.data.groups);
        if (res.data.success) {
          setGroupInfo(res.data.groups);
        } else {
          throw new Error('グループ取得に失敗しました。');
        }
      } else {
        throw new Error('ログイン前です。');
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    readDB();
    // console.log({ mySurvey });
  }, [user]);

  const editGroupHandler = async (gInfo, e) => {
    e.preventDefault();
    try {
      props.history.push({
        pathname: '/makegroup',
        state: gInfo,
      });
    } catch (error) {
      console.log(error);
    }
  };
  const newGroupHandler = async (e) => {
    e.preventDefault();
    try {
      props.history.push({
        pathname: '/makegroup',
        state: {},
      });
    } catch (error) {
      console.log(error);
    }
  };

  // テーブル強化 PJ Ph.3 拡大: <Column> → columns 配列。テキスト列はソート + 省略、操作列は維持。
  const rawColumns = [
    ellipsisColumn({
      title: 'グループコード',
      dataIndex: 'group_code',
      key: 'group_code',
      width: 180,
      sorter: textSorter('group_code'),
    }),
    ellipsisColumn({
      title: 'グループ名',
      dataIndex: 'group_name',
      key: 'group_name',
      width: 220,
      sorter: textSorter('group_name'),
    }),
    ellipsisColumn({
      title: 'グループ説明',
      dataIndex: 'group_description',
      key: 'group_description',
      width: 300,
      sorter: textSorter('group_description'),
    }),
    {
      // グループ会社構成（系列会社あり）のグループのみ、有効な系列会社数をバッジで表示
      title: '構成',
      key: 'has_affiliates',
      width: 190,
      render: (text, record) =>
        record.has_affiliates ? (
          <StatusBadge tone="info">
            系列会社あり（
            {(record.company || []).filter((c) => c.active !== false).length}
            社）
          </StatusBadge>
        ) : null,
    },
    {
      title: '組織管理',
      key: 'orgmgr',
      width: 110,
      resizable: false,
      render: (text, record) => (
        <span>
          <Button
            size="small"
            onClick={() =>
              props.history.push('/orgmgr?group=' + record.group_code)
            }
          >
            組織管理
          </Button>
        </span>
      ),
    },
    {
      title: '編集',
      key: 'action',
      width: 90,
      resizable: false,
      render: (text, record) => (
        <span>
          <Button
            size="small"
            onClick={(e) => editGroupHandler(record, e)}
            disabled={false}
          >
            編集
          </Button>
        </span>
      ),
    },
  ];

  const { columns, components, scroll, wrapRef } = useResizableColumns(rawColumns);

  return (
    <PageContainer fluid>
      <div ref={wrapRef}>
        <Table
          columns={columns}
          components={components}
          scroll={scroll}
          dataSource={groupInfo}
          size="middle"
          rowKey="_id"
        />
      </div>

      <Button type="primary" size="small" onClick={(e) => newGroupHandler(e)}>
        新規グループ作成
      </Button>
    </PageContainer>
  );
};

export default GroupListPage;
